import styles from "./UnauthaurizedPage.module.sass";

import Footer from "../Login/Footer";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";
import SovosButton from "mosaic-react/sovos-button";
import { SovosIcon } from "mosaic-react";
import { Home } from "mosaic-react-icons";

const NoAccessPage = () => {
    return (
        <div className={styles["root"]}>
            <div className={styles["full-container"]}>
                <Icon name="no-access" style={{ width: 130, height: 130 }} />
                <h2>SAF-T</h2>
                <div className={styles["text-center"]}>
                    <p>You don’t have access to this application.</p>
                    <p>Please contact your administrator for access.</p>
                </div>

                <div className={styles["help-container"]}>
                    <div className={styles["contact-support"]}>
                        <SovosButton
                            size={"medium"}
                            variant={"contained"}
                            backgroundColor="#015FFF"
                            onClick={() => {
                                window.location.href = window.location.origin;
                            }}
                            startIcon={
                                <SovosIcon>
                                    <Home />
                                </SovosIcon>
                            }
                        >
                            Homepage
                        </SovosButton>
                    </div>
                    <SovosButton
                        size={"medium"}
                        variant={"text"}
                        color={"#000000"}
                        onClick={() => (window.location.href = "https://sovos.com/support/")}
                    >
                        Need Help?&nbsp;
                        <span>Contact Support</span>
                    </SovosButton>
                </div>
            </div>
            <Footer className={styles["footer"]} />
        </div>
    );
};

export default NoAccessPage;
